<nav class="inner-navbar-mobile">
    <!-- top -->
    <main-header-navbar-mobile-top [data]="{'top': top, 'logo': logo ,'account' : account, 'aboveTop': aboveTop, 'belowTop': belowTop}"
                                   [is-sidebar-open]="isOpen"
                                   (toggle)="drawer.toggle()">
    </main-header-navbar-mobile-top>
    <!-- /top -->
    <!-- sidebar -->
    <mat-sidenav-container [hasBackdrop]="true" autosize>
        <mat-sidenav #drawer mode="over" [position]="'end'" [autoFocus]="true" [fixedInViewport]="true">
            <main-header-navbar-mobile-side [data]="side"
                                            (toggle)="drawer.close()">
            </main-header-navbar-mobile-side>
        </mat-sidenav>
    </mat-sidenav-container>
    <!-- /sidebar -->
</nav>